var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import "react-multi-carousel/lib/styles.css";
import { useMediaQuery, useTheme } from "@mui/material";
/**
 * Helper function that compares the cards and cards per row values
 * in order to center cards/buttons when there aren't enough to fill a row.
 *
 * @param cardsPerRow the user-set number of cards per row
 * @param numberOfCards the number of card elements in the component
 * @returns MUI grid justify-content value, either "center" or "flex-start"
 */
export const compareCardsPerRowAndCardLength = (cardsPerRow, numberOfCards) => {
    // FIXME: type return
    if (!cardsPerRow || !numberOfCards)
        return "flex-start";
    return numberOfCards < +cardsPerRow ? "center" : "flex-start";
};
/**
 * Helper function that compares the cards and cards per row values
 * in order to center cards/buttons when there aren't enough to fill a row.
 *
 * @param xs: CardsPerRow;
 * @param sm: CardsPerRow;
 * @param md: CardsPerRow;
 * @param lg: CardsPerRow;
 * @returns Returns the number of cards per row based on the user-set number of cards per row.
 *          Uses media queries to compare and return the proper result.
 */
export const getCardsPerRow = ({ xs, sm, md, lg }) => {
    const theme = useTheme();
    const IS_LG = useMediaQuery(theme.breakpoints.up("lg"), { noSsr: true });
    const IS_MD = useMediaQuery(theme.breakpoints.up("md"), { noSsr: true });
    const IS_SM = useMediaQuery(theme.breakpoints.up("sm"), { noSsr: true });
    if (IS_LG && !!lg)
        return lg;
    else if (IS_MD && !!md)
        return md;
    else if (IS_SM && !!sm)
        return sm;
    else
        return xs;
};
/**
 * Helper function that compares the cards and cards per row values
 * in order to center cards/buttons when there aren't enough to fill a row.
 *
 * @param xs: CardsPerRow;
 * @param sm: CardsPerRow;
 * @param md: CardsPerRow;
 * @param lg: CardsPerRow;
 * @param cardsToRender: number | undefined;
 * @returns function results: compareCardsPerRowAndCardLength
 */
export const getJustifiedContentValue = (_a) => {
    var { cardsToRender } = _a, restProps = __rest(_a, ["cardsToRender"]);
    const cardsPerRow = getCardsPerRow(Object.assign({}, restProps));
    return compareCardsPerRowAndCardLength(cardsPerRow, cardsToRender);
};
/**
 * usePinnedModule - Returns height of nav bar and total height of all pinned modules
 *
 * @returns Height off set based on other sticky elements
 */
export const usePinnedModule = (currentItemCardAccordion) => {
    const pinnedModules = document.querySelectorAll(`[id*="PinnedToTop"]`);
    let pinnedModulesHeight = 0;
    let nonPaperPinnedModulesHeight = 0;
    if (pinnedModules === null || pinnedModules === void 0 ? void 0 : pinnedModules.length) {
        pinnedModules.forEach((el, index, arr) => {
            const height = Math.floor(el.getBoundingClientRect().height);
            const prevModule = arr[index - 1];
            const prevModuleIsOnPaper = prevModule === null || prevModule === void 0 ? void 0 : prevModule.closest(".MuiPaper-root:not(#item-card-accordion-root");
            const nextModule = arr[index + 1];
            const nextModuleIsOnPaper = nextModule === null || nextModule === void 0 ? void 0 : nextModule.closest(".MuiPaper-root:not(#item-card-accordion-root");
            const currentItemCardAccordionPaperParent = currentItemCardAccordion === null || currentItemCardAccordion === void 0 ? void 0 : currentItemCardAccordion.closest(".MuiPaper-root:not(#item-card-accordion-root");
            const currentItemCardAccordionIsOnSamePaper = currentItemCardAccordionPaperParent === null || currentItemCardAccordionPaperParent === void 0 ? void 0 : currentItemCardAccordionPaperParent.contains(el);
            const isBeforeRecipeProductModule = currentItemCardAccordion && el.compareDocumentPosition(currentItemCardAccordion) === 4 ? true : false;
            const isOnPaper = el.closest(".MuiPaper-root:not(#item-card-accordion-root)");
            if (isBeforeRecipeProductModule) {
                if (!isOnPaper) {
                    if (!prevModuleIsOnPaper) {
                        nonPaperPinnedModulesHeight = 0;
                    }
                    nonPaperPinnedModulesHeight += height;
                    if (nextModuleIsOnPaper) {
                        nonPaperPinnedModulesHeight = height;
                    }
                }
                else {
                    nonPaperPinnedModulesHeight = 0;
                    if (currentItemCardAccordionIsOnSamePaper) {
                        pinnedModulesHeight += height;
                    }
                }
                pinnedModulesHeight += nonPaperPinnedModulesHeight;
            }
        });
    }
    const navHeader = document.getElementById("OrderFlowHeader");
    const isNavSticky = navHeader && window.getComputedStyle(navHeader, null).getPropertyValue("position") === "sticky";
    let offset = pinnedModulesHeight;
    if (navHeader && isNavSticky) {
        offset += navHeader.offsetHeight;
    }
    return {
        offset,
    };
};
// State setter for the accordion expand/collapse state.
export const handleAccordionClick = (setExpanded) => (_, expanded) => {
    setExpanded((prev) => !prev);
};
